import { KeepRecordingType } from '@fullstory/proto/fs/services/ingestion-settings';
import { useFlags, useNotifications } from '@fullstory/react-hooks';
import { AppDispatch } from '../../types';
import { fullstorySelectors } from '../../selectors';
import { IngestionSettingsRequestActions } from './actions';
import { getRecordingFeatures } from './selectors';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

const { getOrgId } = fullstorySelectors;

export const useRecordingFeatures = () => {
  const dispatch = useDispatch<AppDispatch>();
  const intl = useIntl();
  const notifications = useNotifications();
  const orgId = useSelector(getOrgId);
  const recordingFeatures = useSelector(getRecordingFeatures);

  useEffect(() => {
    dispatch(IngestionSettingsRequestActions.getRecordingFeaturesPublic(orgId)).catch(() => {
      notifications?.error(
        intl.formatMessage({
          defaultMessage: 'Failed to fetch recording settings. Please refresh the page.',
          id: 'HaEf/w',
        }),
        'RECORDING_SETTINGS',
      );
    });
  }, [dispatch, notifications, intl, orgId]);

  return {
    recordingFeatures,
  };
};

export const useKeepPreviewModeEnabled = (): boolean => {
  const flags = useFlags();
  const flagShowFocusSignal = flags.featureFlags().AppShowFocusSignal;
  const { recordingFeatures } = useRecordingFeatures();
  return (
    flagShowFocusSignal &&
    recordingFeatures.keepRecordingType == KeepRecordingType.KEEP_RECORDING_PREVIEW
  );
};
